var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"restriktionen-year"},_vm._l((_vm.monthDates),function(monthDate){return _c('RestriktionenMiniMonth',{key:monthDate.valueOf(),attrs:{"date":monthDate,"restriktionen":_vm.restriktionen},on:{"month-click":function($event){return _vm.$emit('month-click', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }